import React, { createContext, useContext } from 'react';
import { ConfirmationDialog, useConfirmationDialog, ConfirmationDialogProps } from '../components/ConfirmationDialog';

interface DialogContextType {
  confirm: (title: string, message: string, onConfirm: () => void, details?: string[]) => void;
  confirmDelete: (title: string, message: string, onDelete: () => void, details?: string[]) => void;
  alert: (type: 'info' | 'warning' | 'success' | 'error' | 'confirm', title: string, message: string, details?: string[]) => void;
}

const DialogContext = createContext<DialogContextType | undefined>(undefined);

export const useDialog = () => {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error('useDialog must be used within a DialogProvider');
  }
  return context;
};

export const DialogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { dialog, confirm, confirmDelete, alert } = useConfirmationDialog();

  return (
    <DialogContext.Provider value={{ confirm, confirmDelete, alert }}>
      {children}
      {/* Render dialog at the root level, outside any containers */}
      {dialog.isOpen && <ConfirmationDialog {...(dialog as ConfirmationDialogProps)} />}
    </DialogContext.Provider>
  );
};
